import React from "react";

import { ChartStrings } from "constants/constantStrings";

import NoItemsLayout from "pages/Dashboard/NoItemsLayout";

import ChartNoShowTags from "../ChartNoShowTags";

const ChartNoData = props => {
  const { activeLayout, tags } = props;
  const noshowTags = tags.every(tag => !tag.Show);

  return (
    <>
      {activeLayout && tags.length > 0 && noshowTags ? (
        <ChartNoShowTags />
      ) : activeLayout ? (
        <div className="no-data-view chart__no-data">
          <label className="dupont-form-label">{ChartStrings.chartNoDataMsg}</label>
          <ul>
            <li className="descriptionText">{ChartStrings.chartNoDataOption1}</li>
            <li className="descriptionText">{ChartStrings.chartNoDataOption2}</li>
            <li className="descriptionText">{ChartStrings.chartNoDataOption3}</li>
          </ul>
        </div>
      ) : (
        <NoItemsLayout />
      )}
    </>
  );
};

export default ChartNoData;
